module.exports = __webpack_public_path__ + "static/media/18_1.0acaeb82.png";